import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ObjectDataPeriodizationCard } from '../../generic/ObjectDataPeriodizationCard';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ObjectDataPeriodizationCardWidget = (props) => {
    const component = useMemo(() => props.contextCustomer && props.user ? (_jsx(ObjectDataPeriodizationCard, { viewObject: {
            matchedPrimary: props.contextCustomer,
            matchedRelatedByPk: undefined,
            matchedRelatedBySk: undefined,
        }, contextObject: props.contextCustomer, user: props.user, transactionFunctions: props.transactionFunctions, userFunctions: props.userFunctions, userGroupRoles: props.userGroupRoles, userSelectedGroup: props.userSelectedGroup })) : (_jsx(_Fragment, {})), [props.contextCustomer, props.user]);
    return {
        name: 'ObjectDataPeriodizationCard',
        category: 'generic',
        component,
    };
};
